/**
 * Обвязка канала — аватар, имя, подвал. docs/phase-1/05-ui.md §3.5.
 *
 * ПРОЧЕРКИ ВМЕСТО ЧИСЕЛ — ПРАВИЛО 6.2 контракта, и оно не тронуто. Пиксельное соответствие
 * превью и канала недоказуемо: бот не видит, что клиент дорисовывает. Чем правдоподобнее
 * скин, тем меньше поводов усомниться там, где расхождение реально есть, поэтому просмотры
 * и время здесь — прочерки, а не правдоподобные числа.
 *
 * ОГОВОРКА ПЕРЕЕХАЛА В `title` (правка 3.4 от 08.09.2026). Раньше «обвязка канала —
 * иллюстрация…» печаталась ВИДИМОЙ строкой под именем канала — и ровно тот же текст уже
 * висел `title` на подвале. Telegram под именем канала ничего подобного не рисует, а панель
 * превью существует ради реализма: служебная подпись внутри скина ломала именно его. Текст
 * никуда не делся — он на обоих узлах обвязки и доступен наведением, — но глазу его больше
 * не подсовывают. Сам факт «это иллюстрация» продолжают говорить прочерки в подвале.
 *
 * ИМЯ КАНАЛА — НАЗВАНИЕ БРЕНДА из списка бэкенда (`display_name` конфига, провайдер
 * `brand.tsx`), а не id с заглавной буквы: у второго бренда id `agi-boardroom`, и «Agi-boardroom»
 * в шапке поста — не то имя, которое увидит подписчик. Пока списка нет (тесты отдельных
 * экранов, ответ ещё едет) — прежний вид из id.
 */

import type { JSX } from 'react';
import { useBrands } from '../brand.tsx';
import { IconEye } from '../components/icons.tsx';
import styles from './MessagePreview.module.css';

const NOTE = 'обвязка канала — иллюстрация; реальные значения показывает Telegram';

export function ChannelHeader({ brand }: { brand: string }): JSX.Element {
  const titled = useBrands().list?.find((b) => b.id === brand)?.title;
  const name =
    titled ?? (brand.length === 0 ? 'канал' : brand.charAt(0).toUpperCase() + brand.slice(1));
  return (
    <div className="tg-ch" title={NOTE}>
      <span className="tg-ava" aria-hidden="true">
        {name.slice(0, 2).toUpperCase()}
      </span>
      <div>
        <div className="tg-chname">{name}</div>
      </div>
    </div>
  );
}

export function ChannelFooter(): JSX.Element {
  return (
    <div className="tg-foot" title={NOTE}>
      <IconEye className={styles['footIcon']} />
      <span>—</span>
      <span>·</span>
      <span>—:—</span>
    </div>
  );
}
